import type {
    AccountTypeAccountsDto,
    ResearchTransactionFilterModelDto,
} from '@treasury/api/channel';

type PaymentTypeFilter = { type?: string };

export type ResearchTransactionFilters = Partial<
    Omit<ResearchTransactionFilterModelDto, 'paymentTypes' | 'accountTypes' | 'accounts'>
> & {
    paymentTypes?: Array<string | PaymentTypeFilter>;
    accountTypes?: Array<string | AccountTypeAccountsDto>;
    accounts?: Array<{ id?: number; name?: string }>;
};

export const mapResearchTransactionFiltersToRequest = (filters: ResearchTransactionFilters) => ({
    ...filters,
    paymentTypes: filters.paymentTypes?.map(
        (entry): PaymentTypeFilter => (typeof entry === 'string' ? { type: entry } : entry)
    ),
    accountTypes: filters.accountTypes?.map(
        (entry): AccountTypeAccountsDto => (typeof entry === 'string' ? { name: entry } : entry)
    ),
});
